var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-default',[_c('div',{staticClass:"box"},[_c('model-gltf',{attrs:{"src":_vm.pt,"backgroundAlpha":.5,"backgroundColor":"#FF0000"}}),_vm._v(" aqui esta "+_vm._s(_vm.pt)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }